/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
import React, { useState, useRef, useEffect } from 'react';
import './TabContents.scss';
import { Document, Page } from 'react-pdf/dist/entry.webpack';
import { injectIntl } from 'react-intl';
import throttle from 'lodash/throttle';
import { isMobileOnly } from 'react-device-detect';

import { PdfLoader } from '../components';

const PDFViewer = (props) => {
  const [numPages, setNumPages] = useState(null);
  const [width, setWidth] = useState(800);

  const { intl: { formatMessage } } = props;

  const pdfWrapper = useRef(null);

  const setDivSize = () => {
    if (pdfWrapper.current && pdfWrapper.current.getBoundingClientRect()) {
      const w = pdfWrapper.current.getBoundingClientRect().width;
      // setWidth(w > 350 ? w : 350);
      setWidth(isMobileOnly ? 330 : w > 350 ? w : 800);
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setDivSize();
  };

  useEffect(() => {
    setDivSize();

    window.addEventListener('resize', throttle(setDivSize, 800));

    return () => {
      window.removeEventListener('resize', throttle(setDivSize, 800));
    };
  }, []);

  useEffect(() => {
    setDivSize();
  }, [props.url]);


  return (
    <section className="pdf-wrapper" ref={pdfWrapper} style={{ margin: '10px' }}>
      <Document
        file={props.url}
        onLoadSuccess={onDocumentLoadSuccess}
        padding={20}
        error={formatMessage({ id: 'preview.error' })}
        loading={(<PdfLoader />)}
        noData={(<PdfLoader />)}
      >
        {
      Array.from(
        new Array(numPages),
        (el, index) => (<Page key={`page_${index + 1}`} pageNumber={index + 1} width={width} />),
      )
    }
      </Document>
    </section>
  );
};

export default injectIntl(PDFViewer);
